import {UserPurchaseManagements} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getUserPurchaseManagements(context, pagination) {
        return UserPurchaseManagements.getUserPurchaseManagements(pagination).then((response) => {
            return response.data;
        });
    },
    getUserPurchaseManagement(context, id) {
        return UserPurchaseManagements.get({id}).then((response) => {
            return response.data;
        });
    },
    createUserPurchaseManagement(context, item) {
        return UserPurchaseManagements.create(item).then((response) => {
            return response.data;
        });
    },
    updateUserPurchaseManagement(context, item) {
        return UserPurchaseManagements.update(item).then((response) => {
            return response.data;
        });
    },
    destroyUserPurchaseManagement(context, item) {
        return UserPurchaseManagements.destroy(item).then((response) => {
            return response.data;
        });
    },
    getUserPurchaseManagementField(context, item) {
        return UserPurchaseManagements.getUserPurchaseManagementField(item).then((response) => {
            return response.data;
        });
    },
    importUserPurchaseManagement(context, item) {
        return UserPurchaseManagements.importUserPurchaseManagement(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
